function UploadImageReducer(state, action) {
  const { value, module } = action.payload;

  switch (action.type) {
    case 'setUuidForImageUpload':
      return {
        ...state,
        [module]: {
          ...state?.[module],
          uuid: value,
        },
      };

    default:
      return state;
  }
}
export default UploadImageReducer;
